import SectionTitle from "@/components/SectionTitle";
import ProjectCard from "@/components/ProjectCard";
import { PROJECTS } from "@/data/projects";

export default function Projects() {
  return (
    <section className="relative py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <SectionTitle
          eyebrow="Projects"
          title="Selected work"
          subtitle="A snapshot of recent projects that blend design, performance, and delightful motion."
          center
        />

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
          {PROJECTS.slice(0, 6).map((p) => (
            <ProjectCard
              key={p.title}
              image={p.image}
              title={p.title}
              description={p.description}
              tags={p.tags}
              live={p.live}
              repo={p.repo}
              onClick={p.onClick}
            />
          ))}
        </div>
      </div>

      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute left-[6%] top-[18%] h-24 w-24 rounded-full bg-neon-mint/20 blur-2xl" />
        <div className="absolute right-[8%] bottom-[12%] h-28 w-28 rounded-full bg-neon-pink/20 blur-2xl" />
      </div>
    </section>
  );
}